import { graphql } from '@/gql';
import type { FetchSubsidyAllowancesByPartnerQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchSubsidyAllowancesByPartner = async ({ partnerCodeName }: FetchSubsidyAllowancesByPartnerQueryVariables) => {
  const response = await queryExecute({
    query: graphql(`
      query FetchSubsidyAllowancesByPartner($partnerCodeName: String!) {
        fetchSubsidyAllowancesByPartner(partnerCodeName: $partnerCodeName) {
          id
          partnerId
          allowanceName
          kind
          isPartnerLevel
          renewAmount
          renewedAt
          renewTimeAmt
          renewTimeUnit
          isRollOver
          isRenewEnabled
          useAsSingleValue
          budgetLimit
          isPreAuthorizationNumberRequired
          data
        }
      }
    `),
    variables: { partnerCodeName },
    fetchPolicy: 'no-cache',
  });

  return response.data?.fetchSubsidyAllowancesByPartner ?? [];
};
